<div>
  <h2>Seleccione su dirección</h2>
</div>
<mat-dialog-content>
  <div>
    <input matInput class="my-search-box" (keydown.enter)="$event.preventDefault()" placeholder="Buscar dirección"
      type="text" #search />
  </div>
  <google-map #myGoogleMap width="100%" [zoom]="zoom" [center]="center" [options]="options"
    (mapClick)="eventHandler($event, 'mapClick')" (mapDblclick)="eventHandler($event, 'mapDblclick')"
    (mapDrag)="eventHandler($event, 'mapDrag')" (mapDragend)="eventHandler($event, 'mapDragend')"
    (mapRightclick)="eventHandler($event, 'mapRightclick')"
    (positionChanged)="eventHandler($event, 'marker_positionChanged')"
    (zoomChanged)="eventHandler($event, 'zoomChanged')">
    <map-marker #markerElem="mapMarker" [position]="marker.position" [label]="marker.label" [title]="marker.title"
      [options]="optionsMarker" (mapClick)="openInfo(markerElem, marker.title)"
      (mapDragend)="eventHandler($event, 'mapDragend')"></map-marker>
    <map-info-window class="mapinfowindows">{{ infoContent }}</map-info-window>
  </google-map>
</mat-dialog-content>
<div *ngIf="addressName">
  <div class="addressTxt" *ngIf="addressName">
    <h3>La dirección seleccionada es:</h3>
    <h4>{{ addressName }}</h4>
    <button class="btn" (click)="closeDialog()" mat-button>Confirmar</button>
  </div>
</div>